import type { ReactNode } from "react"
import { cn } from "@/shared/lib/cn"

/**
 * Entrada por scroll: opacidade + deslocamento vertical.
 *
 * O estado `inView` vem de fora (useInView na secao) em vez de um observer por
 * item. Com um observer por card, uma grade de doze planos criaria doze
 * observers para animar tudo no mesmo instante.
 */

export type RevealDistance = "sm" | "md" | "lg"

const HIDDEN: Record<RevealDistance, string> = {
  sm: "opacity-0 translate-y-5",
  md: "opacity-0 translate-y-6",
  lg: "opacity-0 translate-y-8",
}

export interface RevealProps {
  inView: boolean
  /** Escalonamento em cascata. Tipicamente `index * 80`. */
  delayMs?: number
  distance?: RevealDistance
  className?: string
  children: ReactNode
}

export function Reveal({ inView, delayMs = 0, distance = "md", className, children }: RevealProps) {
  return (
    <div
      className={cn(
        "transition-all duration-700",
        inView ? "opacity-100 translate-y-0" : HIDDEN[distance],
        className,
      )}
      style={{ transitionDelay: inView ? `${delayMs}ms` : "0ms" }}
    >
      {children}
    </div>
  )
}
